.composer {
  padding: 0 var(--space-4) var(--space-4);
}

.inner {
  max-width: 860px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* A floating card like in the click demo; the focus ring sits on the card, not on the borderless field. */
.row {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  padding: var(--space-2);
  border-radius: 14px;
  background: var(--surface);
  box-shadow: 0 3px 8px rgb(2 48 71 / 10%);
}

.row:focus-within {
  box-shadow:
    0 0 0 2px var(--accent),
    0 3px 8px rgb(2 48 71 / 10%);
}

.text {
  flex: 1;
  min-width: 0;
  min-height: 44px;
  font: inherit;
  resize: none;
  border: 0;
  padding: 11px var(--space-2);
  background: transparent;
  color: var(--text);
  max-height: 15em;
}

.text:focus {
  outline: none;
}

.text::placeholder {
  color: var(--muted);
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  flex: none;
  min-height: 44px;
  padding: 0 18px;
  border: 0;
  border-radius: var(--radius);
  background: var(--surface-2);
  color: var(--text);
  font-weight: 700;
  cursor: pointer;
}

.attach {
  composes: button;
  width: 44px;
  padding: 0;
}

.send {
  composes: button;
  background: var(--accent);
  color: var(--accent-text);
}

.stop {
  composes: button;
  background: var(--danger-soft);
  color: var(--danger);
}

.button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* Command chips like in the click demo: bold command, muted hint. */
.commands {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.command {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  min-height: 36px;
  padding: 0 12px;
  border: 0;
  border-radius: 999px;
  background: var(--surface-2);
  color: var(--text);
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}

.command span {
  color: var(--muted);
}

.command:disabled {
  opacity: 0.5;
  cursor: default;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.chip {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 2px var(--space-3);
  font-size: 13px;
  background: var(--surface-2);
}

.chipError {
  composes: chip;
  border-color: var(--danger);
  color: var(--danger);
}

.chip button {
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0;
}

.drop {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--accent-soft) 85%, transparent);
  border: 2px dashed var(--accent);
  font-weight: 600;
  z-index: 2;
  pointer-events: none;
}

.hidden {
  display: none;
}
